import { NavigationCombined } from './type';

export const admin = (internal: boolean, urlPrefix = ''): NavigationCombined => {
  return {
    app: 'admin',
    order: 10,
    adminOnly: true,
    label: 'Admin',
    icon: 'admin_panel_settings',
    flat: true,
    prefix: 'admin',
    title: 'Admin',
    link: !internal ? `${urlPrefix}/admin` : null,
    route: internal ? ['/', 'admin'] : null,
  };
};
